import { Routes } from '@angular/router';

export const adminRoutes: Routes = [
  { path: '', redirectTo: 'impersonate', pathMatch: 'full' },
  { 
    path: 'impersonate', 
    pathMatch: 'full', 
    loadComponent: () => import('./impersonate/impersonate.component').then(m => m.ImpersonateComponent) 
  },
  { 
    path: 'payments',
    pathMatch: 'full', 
    loadComponent: () => import('./manual-payments/manual-payments.component').then(m => m.ManualPaymentsComponent) 
  },
  { 
    path: 'notifications', 
    pathMatch: 'full', 
    loadComponent: () => import('./notifications/notifications.component').then(m => m.NotificationsComponent) 
  },
  { 
    path: 'delete-accounts', 
    pathMatch: 'full', 
    loadComponent: () => import('./delete-accounts/delete-accounts.component').then(m => m.DeleteAccountsComponent) 
  },
  { 
    path: 'qrcodes',
    pathMatch: 'full',
    loadComponent: () => import('./qrcode-generator/qrcode-generator.component').then(m => m.QrcodeGeneratorComponent)
  },
  { 
    path: 'sms-logs', 
    pathMatch: 'full', 
    loadComponent: () => import('./sms-logs/sms-logs.component').then(m => m.SMSLogsComponent) 
  },
  { 
    path: 'marketing-modal',
    pathMatch: 'full', 
    loadComponent: () => import('./admin-marketing-modal/admin-marketing-modal.component').then(m => m.AdminMarketingModalComponent) 
  },
  {
    path: 'edit-merchant',
    pathMatch: 'full',
    loadComponent: () => import('./edit-merchant/edit-merchant.component').then(m => m.EditMerchantComponent)
  },
  { 
    path: 'marketing-modal/new', 
    pathMatch: 'full', 
    loadComponent: () => import('./admin-marketing-modal-form/admin-marketing-modal-form.component').then(m => m.AdminMarketingModalFormComponent) 
  },
  { 
    path: 'marketing-modal/:id', 
    pathMatch: 'full', 
    loadComponent: () => import('./admin-marketing-modal-form/admin-marketing-modal-form.component').then(m => m.AdminMarketingModalFormComponent) 
  },
  {
    path: 'sql-drafts',
    pathMatch: 'full',
    loadComponent: () => import('./sql-drafts/sql-drafts-list/sql-drafts-list.component').then(m => m.SqlDraftsListComponent),
  },
  {
    path: 'sql-drafts/:id',
    pathMatch: 'full',
    loadComponent: () => import('./sql-drafts/sql-draft-detail/sql-draft-detail.component').then(m => m.SqlDraftDetailComponent),
  },
  {
    path: 'teya-onboarding',
    pathMatch: 'full',
    loadComponent: () => import('./teya-onboarding/teya-onboarding-list/teya-onboarding-list.component').then(m => m.TeyaOnboardingListComponent),
  },
  {
    path: 'teya-onboarding/:id',
    pathMatch: 'full',
    loadComponent: () => import('./teya-onboarding/teya-onboarding-detail/teya-onboarding-detail.component').then(m => m.TeyaOnboardingDetailComponent),
  },
];
